import axios from 'axios'
import { saveAs } from 'file-saver'
import { arrayBufferToBlob } from 'blob-util'

export default {
  portfolioExportRequest(students) {
    const query = {
      params: {
        students
      },
      responseType: 'arraybuffer'
    }
    axios.get('/api/admins/students/xlsx/portfolio', query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data), response.headers['content-disposition'].replace('attachment; filename=', ''))
        },
        (error) => {
          console.log(error)
        },
      )
  }
}
